<img
  *ngIf="imageId"
  [id]="imageId"
  [src]="img || getFileURI()"
  (error)="errorImg.emit()"
  alt="image"
  [ngStyle]="imageStyles"
  loading="lazy">
